import { render } from "./FDMessenger.vue?vue&type=template&id=51ba81d2&scoped=true"
import script from "./FDMessenger.vue?vue&type=script&lang=js"
export * from "./FDMessenger.vue?vue&type=script&lang=js"

import "./FDMessenger.vue?vue&type=style&index=0&id=51ba81d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51ba81d2"]])

export default __exports__